import api from './api';

export const landingPageImportService = {
  // Import leads from landing page submissions
  importLeads: async () => {
    try {
      const response = await api.post('/api/landing-page-import');
      return response.data.data;
    } catch (error) {
      console.error('Error importing leads from landing page:', error);
      throw error;
    }
  },

  // Get count of landing page submissions
  getSubmissionCount: async () => {
    try {
      const response = await api.get('/api/landing-page-import/count');
      return response.data.data.count;
    } catch (error) {
      console.error('Error getting landing page submission count:', error);
      throw error;
    }
  }
};

export default landingPageImportService;
